import { API } from ".";


export const sendInvitations = async (token, emails) => {
    try {
        const response = await API.post('/invitation', { emails }, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || "Failed to send invitations";
    }

};

export const getCommonTimeSlots = async (token, inviteId, startTime, endTime, tz='utc') => {
    try {
        const response = await API.get(`/invitation/${inviteId}/common-time`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { startTime, endTime, tz }, // Pass startTime and endTime as query parameters
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || "Failed to fetch common time slots";
    }
};


export const bookCustomTimeSlot = async (token, inviteId, startTime, endTime) => {
    try {
        const response = await API.post(`/invitation/${inviteId}/book-custom-time`,
            { startTime, endTime },
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response?.data || "Failed to book time slot";
    }
}

export const getInviteDetails = async (inviteId) => {
    try {
        const response = await API.get(`/invitation/${inviteId}/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || "Failed to fetch invitations";
    }
}